import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';
import type { IDropdownItemLabelProps } from '@/components/Basic/PropInterfaces/IDropdownItemLabelProps';

type IDropdownItemLabel = {
    [K in keyof IDropdownItemLabelProps]: undefined extends IDropdownItemLabelProps[K]
        ? IDropdownItemLabelProps[K] | Ref<Exclude<IDropdownItemLabelProps[K], undefined>> | undefined
        : IDropdownItemLabelProps[K] | Ref<IDropdownItemLabelProps[K]>;
};

export class DropdownItemLabel extends DropdownItemBase {
    get uniqueLoopKey() {
        return `${this.props.text}`;
    }

    private abuseBlocker: boolean = false;

    public props: IDropdownItemLabelProps;

    private constructor(props: IDropdownItemLabel, hideDropDownItem?: Ref<boolean>) {
        super();
        this.props = reactive(props);
        this.hideDropDownItem = hideDropDownItem;
    }

    public static create(options: IDropdownItemLabel & Pick<DropdownItemBase, 'hideDropDownItem'>): DropdownItemLabel {
        const { hideDropDownItem, ...props } = options;
        return new DropdownItemLabel(props, hideDropDownItem);
    }
}
